import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { HttpClientModule } from '@angular/common/http'
import { ReactiveFormsModule } from '@angular/forms'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { HeaderPageComponent } from './header-page/header-page.component'
import { FooterPageComponent } from './footer-page/footer-page.component'
import { HomePageComponent } from './home-page/home-page.component'
import { HeaderNavigationComponent } from './header-navigation/header-navigation.component'
import { AboutInstituteComponent } from './about-institute/about-institute.component'
import { AboutRgiComponent } from './about-rgi/about-rgi.component'
import { VisionMissionComponent } from './vision-mission/vision-mission.component'
import { ChairmanMessageComponent } from './chairman-message/chairman-message.component'
import { PrincipalMessageComponent } from './principal-message/principal-message.component'
import { CoreValuesComponent } from './core-values/core-values.component'
import { RtiActComponent } from './rti-act/rti-act.component'
import { AdmissionOverviewComponent } from './admission-overview/admission-overview.component'
import { StudentScholarshipComponent } from './student-scholarship/student-scholarship.component'
import { RgiScholarshipComponent } from './rgi-scholarship/rgi-scholarship.component'
import { AdmissionHelplineComponent } from './admission-helpline/admission-helpline.component'
import { FaqsComponent } from './faqs/faqs.component'
import { OnlineFeesPaymentComponent } from './online-fees-payment/online-fees-payment.component'
import { ContactComponent } from './contact/contact.component'
import { AcademicAuditReportsComponent } from './academic-audit-reports/academic-audit-reports.component'
import { ResearchAndPublicationComponent } from './research-and-publication/research-and-publication.component'
import { AcademicsCalendarComponent } from './academics-calendar/academics-calendar.component'
import { PlacementProcessComponent } from './placement-process/placement-process.component'
import { PlacementTeamComponent } from './placement-team/placement-team.component'
import { InternshipComponent } from './internship/internship.component'
import { OurRecruitersComponent } from './our-recruiters/our-recruiters.component'
import { TestimonialsComponent } from './testimonials/testimonials.component'
import { RocsComponent } from './rocs/rocs.component'
import { StudentLifeComponent } from './student-life/student-life.component'
import { SportsComponent } from './sports/sports.component'
import { LibraryComponent } from './library/library.component'
import { LatestNewsComponent } from './latest-news/latest-news.component'
import { LabsComponent } from './labs/labs.component'
import { StudentSpeakComponent } from './student-speak/student-speak.component'
import { AboutAlumniComponent } from './about-alumni/about-alumni.component'
import { AlumniSpeakComponent } from './alumni-speak/alumni-speak.component'
import { AlumniEventsComponent } from './alumni-events/alumni-events.component'
import { CocurricularEventsComponent } from './cocurricular-events/cocurricular-events.component'
import { ExtraCurricularEventsComponent } from './extra-curricular-events/extra-curricular-events.component'
import { EventsComponent } from './events/events.component'
// import { IqacComponent } from './iqac/iqac.component';
import { SsrComponent } from './ssr/ssr.component'
import { ClarificationComponent } from './clarification/clarification.component'
import { KimbaComponent } from './kimba/kimba.component'
import { ClarificationInnerComponent } from './clarification-inner/clarification-inner.component'
import { ImportantLinksComponent } from './important-links/important-links.component'
import { BbaCollegesNagpurComponent } from './bba-colleges-nagpur/bba-colleges-nagpur.component'
import { BccaCollegesNagpurComponent } from './bcca-colleges-nagpur/bcca-colleges-nagpur.component'
import { NotFoundComponent } from './not-found/not-found.component'
import { PlacementDetailsComponent } from './placement-details/placement-details.component'
import { ThankYouComponent } from './thank-you/thank-you.component'
import { CityOfficeComponent } from './city-office/city-office.component'
import { BlogsComponent } from './blogs/blogs.component'
import { BestBbaPlacementCollegesIndiaComponent } from './best-bba-placement-colleges-india/best-bba-placement-colleges-india.component'
import { BachelorOfComputerApplicationComponent } from './bachelor-of-computer-application/bachelor-of-computer-application.component'
import { MasterOfComputerManagementComponent } from './master-of-computer-management/master-of-computer-management.component'
import { MscComputerScienceComponent } from './msc-computer-science/msc-computer-science.component'
import { TmExpressComponent } from './tm-express/tm-express.component'
import { AarambhInductionComponent } from './aarambh-induction/aarambh-induction.component'
import { GoverningBodyComponent } from './governing-body/governing-body.component'
import { BscFinanceComponent } from './bsc-finance/bsc-finance.component'
import { BscEconomicsComponent } from './bsc-economics/bsc-economics.component'
import { BcomHonorsComponent } from './bcom-honors/bcom-honors.component'
import { BaHonorsEonomicsComponent } from './ba-honors-eonomics/ba-honors-eonomics.component'
import { BscDataScienceComponent } from './bsc-data-science/bsc-data-science.component'
import { CommitteeComponent } from './committee/committee.component'
import { InstituteAntiRaggingCommitteeComponent } from './institute-anti-ragging-committee/institute-anti-ragging-committee.component'
import { AntiRaggingSquadComponent } from './anti-ragging-squad/anti-ragging-squad.component'
import { GrievanceRedressalCommitteeComponent } from './grievance-redressal-committee/grievance-redressal-committee.component'
import { WomanDevelopmentCellComponent } from './woman-development-cell/woman-development-cell.component'
import { AntiSexualHarassmentGrievanceCellComponent } from './anti-sexual-harassment-grievance-cell/anti-sexual-harassment-grievance-cell.component'
import { TrainingAndPlacementCellAndThreeCellComponent } from './training-and-placement-cell-and-three-cell/training-and-placement-cell-and-three-cell.component'
import { InternalComplaintCommitteeComponent } from './internal-complaint-committee/internal-complaint-committee.component'
import { FutureOfBScDataScienceComponent } from './future-of-bsc-data-science/future-of-bsc-data-science.component'
import { BlogScheduleComponent } from './blog-schedule/blog-schedule.component'
import { BscInFinanceComponent } from './bsc-in-finance/bsc-in-finance.component'
import { AdmissionInBBAComponent } from './admission-in-bba/admission-in-bba.component'
import { MscInComputerScienceComponent } from './msc-in-computer-science/msc-in-computer-science.component'
import { TopBCACollegesInIndiaComponent } from './top-bca-colleges-in-india/top-bca-colleges-in-india.component'
import { FeesStructuresComponent } from './fees-structures/fees-structures.component'
import { FutureOfDataScienceComponent } from './future-of-data-science/future-of-data-science.component'
import { SpecializationForYourMScInComputerScienceComponent } from './specialization-for-your-m-sc-in-computer-science/specialization-for-your-m-sc-in-computer-science.component'
import { TopMastersProgramsInComputerManagementComponent } from './top-masters-programs-in-computer-management/top-masters-programs-in-computer-management.component'
import { BComHonoursProgramComponent } from './b-com-honours-program/b-com-honours-program.component'
import { BscEconomicsAndFinanceComponent } from './bsc-economics-and-finance/bsc-economics-and-finance.component'
import { EngfinityClubInstallationPressReleaseComponent } from './engfinity-club-installation-press-release/engfinity-club-installation-press-release.component'
import { BestCollegesBaDigitalMarketingNagpurComponent } from './best-colleges-ba-digital-marketing-nagpur/best-colleges-ba-digital-marketing-nagpur.component'
import { BcomComputerApplicationComponent } from './bcom-computer-application/bcom-computer-application.component'
import { BscEconomicsProgramTipsComponent } from './bsc-economics-program-tips/bsc-economics-program-tips.component'
import { FutureBscItCareerOpportunitiesComponent } from './future-bsc-it-career-opportunities/future-bsc-it-career-opportunities.component'
import { BusinessGuideBbaCoursesComponent } from './business-guide-bba-courses/business-guide-bba-courses.component'
import { ECommerceDigitalMarketingEnhancingComponent } from './e-commerce-digital-marketing-enhancing/e-commerce-digital-marketing-enhancing.component'
import { GyanManthanComponent } from './gyan-manthan/gyan-manthan.component'
import { ToastmastersClubComponent } from './toastmasters-club/toastmasters-club.component'
import { InductionProgramComponent } from './induction-program/induction-program.component'
import { RaisoniMandiComponent } from './raisoni-mandi/raisoni-mandi.component'
import { FarewellPartyComponent } from './farewell-party/farewell-party.component'
import { FarewellCeremonyComponent } from './farewell-ceremony/farewell-ceremony.component'
import { CynosureComponent } from './cynosure/cynosure.component'
import { InstallationProgramComponent } from './installation-program/installation-program.component'
import { RakhiMakingCompetitionComponent } from './rakhi-making-competition/rakhi-making-competition.component'
import { MissionVotingCampingComponent } from './mission-voting-camping/mission-voting-camping.component'
import { GaneshChaturthiComponent } from './ganesh-chaturthi/ganesh-chaturthi.component'
import { InstallationCeremonyComponent } from './installation-ceremony/installation-ceremony.component'
import { BigBossComponent } from './big-boss/big-boss.component'
import { EngfinityClubComponent } from './engfinity-club/engfinity-club.component'
import { TopBscFinanceCollegesNagpurComponent } from './top-bsc-finance-colleges-nagpur/top-bsc-finance-colleges-nagpur.component'
import { DeepMilanComponent } from './deep-milan/deep-milan.component'
import { NewsAnalysisComponent } from './news-analysis/news-analysis.component'
import { MandatoryDisclosureComponent } from './mandatory-disclosure/mandatory-disclosure.component'
import { McmCourseInNagpurComponent } from './mcm-course-in-nagpur/mcm-course-in-nagpur.component'
import { MscComputerScienceCollegesInNagpurComponent } from './msc-computer-science-colleges-in-nagpur/msc-computer-science-colleges-in-nagpur.component'
import { KiteFlyingFestivalComponent } from './kite-flying-festival/kite-flying-festival.component'
import { FarewellPartyTwentyfiveComponent } from './farewell-party-twentyfive/farewell-party-twentyfive.component'
import { Engfinity2025Component } from './engfinity2025/engfinity2025.component'
import { CreatingUnicornComponent } from './creating-unicorn/creating-unicorn.component'
import { MissNationCompetitionComponent } from './miss-nation-competition/miss-nation-competition.component'
import { PickleballInaugurationComponent } from './pickleball-inauguration/pickleball-inauguration.component'
import { ToastmastersComponent } from './toastmasters/toastmasters.component'
import { SadaGyanSeriesComponent } from './sada-gyan-series/sada-gyan-series.component'
import { EventsNewComponent } from './events-new/events-new.component';
import { KashtiInaugurationComponent } from './kashti-inauguration/kashti-inauguration.component';
import { RaisoniPremierLeagueComponent } from './raisoni-premier-league/raisoni-premier-league.component';
import { ChatrapatiShivajiMaharajJayntiComponent } from './chatrapati-shivaji-maharaj-jaynti/chatrapati-shivaji-maharaj-jaynti.component';
import { SetuComponent } from './setu/setu.component';
import { RaheComponent } from './rahe/rahe.component';
import { FarewellComponent } from './farewell/farewell.component'

@NgModule({
  declarations: [
    AppComponent,
    HeaderPageComponent,
    FooterPageComponent,
    HomePageComponent,
    HeaderNavigationComponent,
    AboutInstituteComponent,
    AboutRgiComponent,
    VisionMissionComponent,
    ChairmanMessageComponent,
    PrincipalMessageComponent,
    CoreValuesComponent,
    RtiActComponent,
    AdmissionOverviewComponent,
    StudentScholarshipComponent,
    RgiScholarshipComponent,
    AdmissionHelplineComponent,
    FaqsComponent,
    OnlineFeesPaymentComponent,
    ContactComponent,
    AcademicAuditReportsComponent,
    ResearchAndPublicationComponent,
    AcademicsCalendarComponent,
    PlacementProcessComponent,
    PlacementTeamComponent,
    InternshipComponent,
    OurRecruitersComponent,
    TestimonialsComponent,
    RocsComponent,
    StudentLifeComponent,
    SportsComponent,
    LibraryComponent,
    LatestNewsComponent,
    LabsComponent,
    StudentSpeakComponent,
    AboutAlumniComponent,
    AlumniSpeakComponent,
    AlumniEventsComponent,
    CocurricularEventsComponent,
    ExtraCurricularEventsComponent,
    EventsComponent,
    // IqacComponent,
    SsrComponent,
    ClarificationComponent,
    KimbaComponent,
    ClarificationInnerComponent,
    ImportantLinksComponent,
    BbaCollegesNagpurComponent,
    BccaCollegesNagpurComponent,
    NotFoundComponent,
    PlacementDetailsComponent,
    ThankYouComponent,
    CityOfficeComponent,
    BlogsComponent,
    BestBbaPlacementCollegesIndiaComponent,
    BachelorOfComputerApplicationComponent,
    MasterOfComputerManagementComponent,
    MscComputerScienceComponent,
    TmExpressComponent,
    AarambhInductionComponent,
    GoverningBodyComponent,
    BscFinanceComponent,
    BscEconomicsComponent,
    BcomHonorsComponent,
    BaHonorsEonomicsComponent,
    BscDataScienceComponent,
    CommitteeComponent,
    InstituteAntiRaggingCommitteeComponent,
    AntiRaggingSquadComponent,
    GrievanceRedressalCommitteeComponent,
    WomanDevelopmentCellComponent,
    AntiSexualHarassmentGrievanceCellComponent,
    TrainingAndPlacementCellAndThreeCellComponent,
    InternalComplaintCommitteeComponent,
    FutureOfBScDataScienceComponent,
    BlogScheduleComponent,
    BscInFinanceComponent,
    AdmissionInBBAComponent,
    MscInComputerScienceComponent,
    TopBCACollegesInIndiaComponent,
    FeesStructuresComponent,
    FutureOfDataScienceComponent,
    SpecializationForYourMScInComputerScienceComponent,
    TopMastersProgramsInComputerManagementComponent,
    BComHonoursProgramComponent,
    BscEconomicsAndFinanceComponent,
    EngfinityClubInstallationPressReleaseComponent,
    BestCollegesBaDigitalMarketingNagpurComponent,
    BcomComputerApplicationComponent,
    BscEconomicsProgramTipsComponent,
    FutureBscItCareerOpportunitiesComponent,
    BusinessGuideBbaCoursesComponent,
    ECommerceDigitalMarketingEnhancingComponent,
    GyanManthanComponent,
    ToastmastersClubComponent,
    InductionProgramComponent,
    RaisoniMandiComponent,
    FarewellPartyComponent,
    FarewellCeremonyComponent,
    CynosureComponent,
    InstallationProgramComponent,
    RakhiMakingCompetitionComponent,
    MissionVotingCampingComponent,
    GaneshChaturthiComponent,
    InstallationCeremonyComponent,
    BigBossComponent,
    EngfinityClubComponent,
    TopBscFinanceCollegesNagpurComponent,
    DeepMilanComponent,
    NewsAnalysisComponent,
    MandatoryDisclosureComponent,
    McmCourseInNagpurComponent,
    MscComputerScienceCollegesInNagpurComponent,
    KiteFlyingFestivalComponent,
    FarewellPartyTwentyfiveComponent,
    Engfinity2025Component,
    CreatingUnicornComponent,
    MissNationCompetitionComponent,
    PickleballInaugurationComponent,
    ToastmastersComponent,
    SadaGyanSeriesComponent,
    EventsNewComponent,
    KashtiInaugurationComponent,
    RaisoniPremierLeagueComponent,
    ChatrapatiShivajiMaharajJayntiComponent,
    SetuComponent,
    RaheComponent,
    FarewellComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
